var o=function(o){var r=typeof o;return"string"==r||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==o:null===o};export{o as _};
